import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

import {
  FaHome,
  FaUsers,
  FaUserTie,
  FaBuilding,
  FaCity,
  FaStore,
  FaCalendarCheck,
  FaFileAlt,
  FaChevronDown,
  FaFileInvoiceDollar,
  FaBars,
  FaTimes,
  FaFileContract,
  FaUserSecret,
  FaUserGraduate,
  FaBriefcase,
  FaTasks,
  FaTh,
  FaComments,
  FaHandshake,
  FaCheckCircle,
  FaPlusSquare,
  FaListAlt,
  FaUniversity,
  FaReceipt,
  FaMoneyCheckAlt,
} from "react-icons/fa";

export default function SideNavigation({ mobileOpen, setMobileOpen }) {
  const navigate = useNavigate();
  const location = useLocation();

  const currentRoute = location.pathname;

  const [openDashboard, setOpenDashboard] = useState(true);
  const [openReports, setOpenReports] = useState(false);
  const [openBilling, setOpenBilling] = useState(false);

  useEffect(() => {
    if (dashboardMenu.some((item) => item.route === currentRoute)) {
      setOpenDashboard(true);
    }
    if (reportsMenu.some((item) => item.route === currentRoute)) {
      setOpenReports(true);
    }
    if (billingMenu.some((item) => item.route === currentRoute)) {
      setOpenBilling(true);
    }
  }, [currentRoute]);

  const goTo = (route) => {
    navigate(route);
    setMobileOpen(false);
  };

  // =====================================================
  // MENUS
  // =====================================================

  const dashboardMenu = [
    { label: "Employees", icon: <FaUsers />, route: "/employee" },
    { label: "Designation", icon: <FaUserTie />, route: "/designation" },
    { label: "Department", icon: <FaBuilding />, route: "/department" },
    { label: "Branch", icon: <FaCity />, route: "/branch" },
    { label: "Vendors", icon: <FaStore />, route: "/vendor" },
    // {
    //   label: "Employee Leaves",
    //   icon: <FaCalendarCheck />,
    //   route: "/holidaychart",
    // },
  ];

  const reportsMenu = [
    {
      label: "Closing Report",
      icon: <FaFileContract />,
      route: "/closingreport",
    },
    {
      label: "Recruiter Report",
      icon: <FaUserSecret />,
      route: "/recruiter-report",
    },
    {
      label: "Candidate Report",
      icon: <FaUserGraduate />,
      route: "/candidate-report",
    },
    {
      label: "BD Report",
      icon: <FaBriefcase />,
      route: "/bd-report",
    },
    {
      label: "Working Report",
      icon: <FaTasks />,
      route: "/submission-report",
    },
    {
      label: "Position Matrix",
      icon: <FaTh />,
      route: "/matrix",
    },
    {
      label: "Interview Report",
      icon: <FaComments />,
      route: "/interview-report",
    },
    {
      label: "Joining Report",
      icon: <FaHandshake />,
      route: "/joining-report",
    },
    {
      label: "Closure Report",
      icon: <FaCheckCircle />,
      route: "/closure-report",
    },
    // {
    //   label: "Admin Setting",
    //   icon: <FaCheckCircle />,
    //   route: "/admin-setting",
    // },
  ];

  const billingMenu = [
    {
      label: "New Invoice",
      icon: <FaPlusSquare />,
      route: "/new-invoice",
    },
    {
      label: "Invoice List",
      icon: <FaListAlt />,
      route: "/invoive_master",
    },
    {
      label: "Company List",
      icon: <FaUniversity />,
      route: "/company_list",
    },
    {
      label: "Invoice Report",
      icon: <FaReceipt />,
      route: "/invoice-report",
    },
    {
      label: "Payment Report",
      icon: <FaMoneyCheckAlt />,
      route: "/payment-report",
    },
  ];

  // =====================================================
  // SIDEBAR SECTION
  // =====================================================

  const SidebarSection = ({
    title,
    icon,
    open,
    setOpen,
    items,
  }) => (
    <div className="mb-2">
      <button
        onClick={() => setOpen(!open)}
        className="
          w-full
          flex
          items-center
          justify-between
          px-4
          py-2.5
          rounded-xl
          hover:bg-slate-100/60
          dark:hover:bg-slate-800/40
          transition-all
          duration-200
        "
      >
        <span className="flex items-center gap-3 text-sm font-medium text-slate-700 dark:text-slate-300">
          <span className="text-indigo-650 dark:text-indigo-400">{icon}</span>
          {title}
        </span>

        <FaChevronDown
          className={`text-[10px] text-slate-400 dark:text-slate-500 transition-transform duration-200 ${open ? "rotate-180" : ""
            }`}
        />
      </button>

      <div
        className={`
          overflow-hidden
          transition-all
          duration-300
          ${open ? "max-h-[600px]" : "max-h-0"}
        `}
      >
        <div className="mt-1 flex flex-col gap-1 pl-3 border-l border-slate-200 dark:border-slate-800 ml-5">
          {items.map((item, idx) => (
            <button
              key={idx}
              onClick={() => goTo(item.route)}
              className={`
                flex
                items-center
                gap-3
                px-4
                py-2
                rounded-xl
                text-xs
                transition-all
                duration-200
                active:scale-[0.98]

                ${currentRoute === item.route
                  ? "bg-indigo-50/80 dark:bg-indigo-950/40 text-indigo-700 dark:text-indigo-300 font-semibold border-l-4 border-indigo-600 scale-[1.01]"
                  : "text-slate-600 dark:text-slate-400 hover:bg-slate-100/40 dark:hover:bg-slate-800/40 hover:text-slate-900 dark:hover:text-slate-200"
                }
              `}
            >
              <span className="text-xs text-indigo-500 dark:text-indigo-400">
                {item.icon}
              </span>

              {item.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {/* ===================================================== */}
      {/* OVERLAY */}
      {/* ===================================================== */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-slate-900/20 backdrop-blur-xs z-40 md:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* ===================================================== */}
      {/* SIDEBAR CONTAINER */}
      {/* ===================================================== */}
      <aside
        className={`
          fixed
          top-0
          left-0
          h-screen
          w-72
          glass-panel
          z-50
          transition-transform
          duration-300

          ${mobileOpen ? "translate-x-0" : "-translate-x-full"}
          md:translate-x-0
        `}
      >
        {/* ===================================================== */}
        {/* LOGO */}
        {/* ===================================================== */}
        <div
          className="
            h-20
            flex
            items-center
            justify-between
            px-6
            border-b
            border-slate-150
            dark:border-slate-800/40
          "
        >
          <div>
            <h1
              onClick={() => goTo("/adminhome")}
              className="
                text-2xl
                font-extrabold
                tracking-tight
                cursor-pointer
                text-transparent
                bg-clip-text
                bg-gradient-to-r
                from-indigo-600
                to-indigo-800
                dark:from-indigo-400
                dark:to-violet-400
              "
            >
              MORGAN
            </h1>
            <p className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mt-0.5">
              HRMS ADMIN PANEL
            </p>
          </div>

          <button
            className="md:hidden p-2 text-slate-400 hover:text-slate-700 hover:bg-slate-50 rounded-xl transition-all"
            onClick={() => setMobileOpen(false)}
          >
            <FaTimes size={14} />
          </button>
        </div>

        {/* ===================================================== */}
        {/* NAVIGATION */}
        {/* ===================================================== */}
        <nav
          className="
            p-4
            overflow-y-auto
            h-[calc(100vh-80px)]
            scrollbar-thin
          "
        >
          {/* Dashboard Home */}
          <button
            onClick={() => goTo("/adminhome")}
            className={`
              w-full
              flex
              items-center
              gap-3
              px-4
              py-2.5
              rounded-xl
              text-sm
              font-medium
              mb-3
              transition-all
              duration-200
              active:scale-[0.98]

              ${currentRoute === "/adminhome"
                ? "bg-indigo-50/80 dark:bg-indigo-950/40 text-indigo-700 dark:text-indigo-300 font-semibold border-l-4 border-indigo-600 scale-[1.01]"
                : "text-slate-650 dark:text-slate-400 hover:bg-slate-100/60 dark:hover:bg-slate-800/40 hover:text-slate-900 dark:hover:text-slate-200"
              }
            `}
          >
            <FaHome size={16} className={currentRoute === "/adminhome" ? "text-indigo-650" : "text-indigo-500"} />
            Dashboard
          </button>

          {/* Sections */}
          <SidebarSection
            title="Management"
            icon={<FaUsers />}
            open={openDashboard}
            setOpen={setOpenDashboard}
            items={dashboardMenu}
          />

          <SidebarSection
            title="Reports"
            icon={<FaFileAlt />}
            open={openReports}
            setOpen={setOpenReports}
            items={reportsMenu}
          />

          <SidebarSection
            title="Billing"
            icon={<FaFileInvoiceDollar />}
            open={openBilling}
            setOpen={setOpenBilling}
            items={billingMenu}
          />

          {/* Extension Download Widget (Hidden for now) */}
          {/*
          <div className="mt-4 pt-3 border-t border-slate-200/60 dark:border-slate-800 px-2">
            <a
              href="/workspace-extension.zip"
              download="workspace-extension.zip"
              className="flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-semibold text-indigo-600 dark:text-indigo-400 bg-indigo-50/80 dark:bg-indigo-950/40 hover:bg-indigo-100 dark:hover:bg-indigo-900/50 border border-indigo-200/60 dark:border-indigo-800/50 transition-all shadow-sm"
              title="Download Chrome Quick Capture Extension (ZIP)"
            >
              <span>⚡</span>
              <span>Download Chrome Tool</span>
            </a>
          </div>
          */}

        </nav>
      </aside>
    </>
  );
}